export default __webpack_public_path__ + "static/media/tree-structure.04ed0bc9.svg";